import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icons/chevron-right-gray.svg'


const _hoisted_1 = {
  key: 0,
  class: "estate-map-options-container"
}
const _hoisted_2 = { class: "options-container" }
const _hoisted_3 = { class: "btn-container" }
const _hoisted_4 = {
  key: 1,
  class: "spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!$setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "button default primary option-btn",
              onClick: $setup.goToEstate
            }, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("p", null, "View available land", -1)
            ]))]),
            ($setup.lotsWithBuilder.length > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button default primary option-btn option-btn-flex",
                  onClick: $setup.goToBuilder
                }, [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("p", { class: "create-home" }, "Create home & land package", -1),
                  _createElementVNode("img", { src: _imports_0 }, null, -1)
                ]))]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["msg-container", { 'msg-no-builder': $setup.lotsWithBuilder.length <= 0 }])
          }, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "message" }, "Got a question? Send us a message and our team will get back to you.", -1)),
            _createElementVNode("button", {
              class: "button default primary option-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emits('onMessage')))
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("p", null, "Message", -1)
            ]))])
          ], 2)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4))
}